import React from "react";
import { BaseAccordion } from "../../../../../../components";
import { OrderInvoiceContent, OrderInvoiceHeader } from "../../../index";

// TYPES
import { OrderInvoiceListProps } from "../../types";

const OrderInvoiceList: React.FC<
	OrderInvoiceListProps & { labels?: Record<string, any> }
> = ({ title, items, fields, currencyCharacter, labels }) => {
	return (
		<>
			{items && (
				<div className="flex flex-col h-full w-full items-center">
					<div className="flex">{title}</div>
					<ul className="w-full">
						{items.map((item, index) => (
							<li
								key={index}
								className={`mb-2 bg-white rounded-lg border-none hover:bg-navy-50`}
							>
								<BaseAccordion
									headerChildren={
										<OrderInvoiceHeader
											item={item}
											labels={labels}
										/>
									}
									children={
										<OrderInvoiceContent
											item={item}
											index={index}
											fieldsConfig={fields}
											containerClasses={"bg-white px-2.5"}
											currencyCharacter={
												currencyCharacter
											}
											labels={labels}
										/>
									}
									accordionParentClasses={"px-2.5 py-2.5"}
									accordionExpandedClasses={
										"bg-white rounded-lg border-none"
									}
								/>
							</li>
						))}
					</ul>
				</div>
			)}
		</>
	);
};

export default OrderInvoiceList;
